import React, {Component} from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from "redux";
import {changeSort} from "../actions/SortActions";
import IframeHelper from "../helpers/IframeHelper";
import SortComponent from "./common/SortComponent";
import Logger from "../helpers/Logger";

class UtilityHeaderContainer extends Component {
    componentDidCatch(error, info) {
        const logger = new Logger(this.props.logPath);
        logger.critical('REACT: error caught in UtilityHeaderContainer', error.toString());
    }

    componentDidUpdate() {
        IframeHelper.updateHeight(this.props.parameters.projectUrl);
    }

    onSortChange(event) {
        this.props.changeSort(event.target.value);
    }

    render() {
        if (this.props.flights.loading) {
            return null;
        }

        const translator =  JSON.parse(this.props.dataTranslations);
        const route = JSON.parse(this.props.parameters.route);

        return (
            <div>
                <div className="row my-2">
                    <div className="col-sm-6 pt-2">
                        <p className="d-none d-lg-block results-route">
                            <span className="results-route-cities">{route.from.general} <span className="results-route-arrow">&rarr;</span> {route.to.general}</span>
                            <span className="text-muted results-route-count">{translator['Found flights']}: {this.props.flights.count}</span>
                        </p>
                    </div>
                    <div className="col-sm-6 clearfix d-none d-lg-block js-filters">
                        <div className="float-right d-none d-lg-block">
                            <SortComponent translations={translator} onSortChange={this.onSortChange.bind(this)} hasEmptyDefault={false}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        changeSort
    }, dispatch);
}

function mapStateToProps(state, ownProps) {
    return {
        dataTranslations: ownProps.translations,
        flights: state.FlightsReducer,
        parameters: state.ParametersReducer.parameters
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UtilityHeaderContainer);

export const DOMAIN = 'utility';



// WEBPACK FOOTER //
// ./src/components/UtilityHeaderContainer.js